// BULK SELECT JOB LIST ***************************************************************************
// pathname: /v3/bulk-operation/select-job-list
// ************************************************************************************************
import { useSwrApi, ApiBulkSelectJobList } from 'src/hooks/useSwrApi';


/**
 * @description Get a list with all the jobs posted by the current user. Used to select jobs for bulk operations.
 *
 * @param locale - the locale
 * @param urlParams - the URL parameters; you can use this to pass the 'selectedJobId' parameter if you want
 * to pre-select a job
 * @param successCallback - callback function to be executed on success (like updateFormElements from useBjForm so the
 * form is re-rendered with the new data)
 *
 * @example
 * // get the list of jobs for bulk operations
 * const { data, error, isLoading, isValidating, mutate } = useSwrSelectJobList('ro');
 */
export const useSwrSelectJobList = (locale = 'ro', urlParams = '', successCallback?: () => void) => {
  const {
    data,
    error,
    isLoading,
    isValidating,
    mutate,
  } = useSwrApi<ApiBulkSelectJobList>({
    url: '/v3/bulk-operation/select-job-list',
    urlParams,
    locale,
    apiOptions: {
      dedupingInterval: 1000 * 60, // 1 minute
      onSuccess: () => {
        if (successCallback) successCallback();
      },
    },
    toastsOptions: {
      showErrorToast: true,
    },
  });

  // Return data
  return {
    data,
    error,
    isLoading,
    isValidating,
    mutate,
  };
};
